
const index = () => {
  return (
    <footer className="footer -type-2 bg-dark-3 text-white">
      <div className="container">
        <div className="pt-60 pb-60">
          <div className="row y-gap-40 justify-between xl:justify-start">
            <div className="col-xl-4 col-lg-6">
              <img src="/img/general/logo.svg" alt="tripsi.pl" className="w-25" /> <br/> Wszelkie prawa zastrzeżone
            </div>
            {/* End .col */}

            <div className="col-xl-4 col-lg-6">
              <div className="row y-gap-30">
                <div className="col-12">
                  <p>Nie pobieramy żadnych dodatkowych opłat za rezerwację. Dokonujesz rezerwacji we własnym imieniu, sugerując się naszymi propozycjami.</p>
                  <nav aria-label="Informacje o Tripsi" className="d-flex flex-wrap x-gap-15 y-gap-10 mt-15">
                    <a href="/o-nas" className="text-white underline">O nas</a>
                    <a href="/zasady-redakcyjne" className="text-white underline">Zasady redakcyjne</a>
                    <a href="/metodologia" className="text-white underline">Metodologia</a>
                    <a href="/blog" className="text-white underline">Blog</a>
                    <a href="/contact" className="text-white underline">Kontakt</a>
                  </nav>
                  <p className="mt-15">Nie ponosimy odpowiedzialności za treść stron ani usługi zewnętrznych dostawców. Prezentujemy optymalne kombinacje lotów i hoteli.</p>
                  <br/><br/>
                  W razie pytań skontaktuj się z nami: kontakt@tripsi.pl
                </div>
                {/* End .col */}
              </div>
              {/* End .row */}
            </div>
            {/* End .col */}

          </div>
          {/* End .row */}
        </div>
        {/* End footer top */}

        <div className="py-20 border-top-white-15">
          {/*<Copyright />*/}
        </div>
        {/* End footer-copyright */}
      </div>
      {/* End container */}
    </footer>
  );
};

export default index;
